const qa = {
  apiKey: 'phc_lXRLF7TLhozka2yqscGzSdWIzhYr0YVyOzlLk18TrvM',
  host: 'https://ph.qa32.circleone.com',
};
const stage = {
  apiKey: 'phc_prPTR2MwMQBKlpx4AFzKPSoCXBaDMouBMVSdekCKlCE',
  host: 'https://ph.stage.circleone.com',
};
const production = {
  apiKey: 'phc_FCi8n3bLtYzJcDoCtFYuX7R5eebM9NCUOAeKaeSq7rd',
  host: 'https://ph.prosper.com',
};

export const getConfig = (hostname: string, isNative: boolean = false) => {
  let config: { apiKey: string; host: string; };

  if (hostname && hostname.includes('stage.circleone.com')) {
    config = stage;
  } else if (hostname && hostname.includes('prosper.com')) {
    config = production;
  } else {
    config = qa;
  }

  if (isNative) {
    switch (process.env.EXPO_PUBLIC_ENV_TYPE) {
      case 'stage':
        config = stage;
        break;
      case 'production':
        config = production;
        break;
      default:
        config = qa;
    }
  }

  return config;
};


export const webOptions = {
  api_host: getConfig((window && window.location && window.location.hostname)).host,
  disable_web_experiments: false,
  session_recording: {
    maskAllInputs: true,
    maskTextSelector: '*',
    maskTextFn: (text, element) => {
      if (element?.dataset['phUnmask'] === 'true') {
        return text;
      }
      return '*'.repeat(text.trim().length);
    },
  },
};


export const nativeOptions = {
  host: getConfig('', true).host,
  enableSessionReplay: true,
  sessionReplayConfig: {
    // Whether text and text input fields are masked. Default is true.
    // Password inputs are always masked regardless
    maskAllImages: false,
    maskAllTextInputs: true,
    // captureLog: true,
    captureNetworkTelemetry: true,
    androidDebouncerDelayMs: 1000,
    iOSdebouncerDelayMs: 1000,
  },
};